import Web3 from 'web3';
import type { provider } from 'web3-core';
import type { AbiItem } from 'web3-utils';

import GTOKEN_ABI from '@/utils/abi/g-token.json';
import LOCK_AIRI_ABI from '@/utils/abi/lock-airi.json';
import { read, write } from '@/utils/web3Service';

import type { EarnValue, LockOption } from '../constants';
import {
  AIG_PERCENT,
  APR_PERCENT,
  CREDIT_PERCENT,
  LOCK_CONTRACT_ADDRESS,
  NetworkKey,
  TOKEN_CONTRACT_ADDRESS,
} from '../constants';

export const getEarnValues = (amount: number, option: LockOption): EarnValue => {
  const credit = (amount * CREDIT_PERCENT[option]) / 100;
  const aig = (amount * AIG_PERCENT[option]) / 100;
  const apr = APR_PERCENT[option];

  return { credit, aig, apr };
};

export const getTokenBalance = async (account: string, address: string): Promise<number> => {
  const balance = await read('balanceOf', address, GTOKEN_ABI as AbiItem[], [account]);
  return balance ? parseInt(Web3.utils.fromWei(balance)) : 0;
};

export const lockAiriToken = async ({
  provider,
  account,
  callback,
  poolId,
  userId,
  amount,
}: {
  provider: provider;
  account: string;
  callback: (hash: string) => void;
  poolId: number;
  amount: string;
  userId: number;
}) => {
  const res = await write(
    'lockAiri',
    provider,
    LOCK_CONTRACT_ADDRESS[NetworkKey.Bsc],
    LOCK_AIRI_ABI as AbiItem[],
    account,
    [poolId, Web3.utils.toWei(amount), userId],
    callback,
  );
  return res;
};

export const getAllowance = async (account: string, tokenAddress: string, lockAddress: string) => {
  const allowance = await read('allowance', tokenAddress, GTOKEN_ABI as AbiItem[], [
    account,
    lockAddress,
  ]);
  return Web3.utils.fromWei(allowance);
};

export const approve = async ({
  provider,
  account,
  callback,
}: {
  provider: provider;
  account: string;
  callback: (hash: string) => void;
}) => {
  return write(
    'approve',
    provider,
    TOKEN_CONTRACT_ADDRESS[NetworkKey.Bsc],
    GTOKEN_ABI as AbiItem[],
    account,
    [LOCK_CONTRACT_ADDRESS[NetworkKey.Bsc], Web3.utils.toWei('999999999999', 'ether')],
    callback,
  );
};
